module.exports = __webpack_public_path__ + "img/icon_pending.97930af9.svg";